/**
 * Event identity belongs to the browser action, rather than a component render.
 * Keep the whole object when retrying the same mutation so the BFF/SDK can
 * deduplicate a response that was accepted before the browser lost its reply.
 */
export const newMetricEvent = () => ({
    eventId: crypto.randomUUID(),
    occurredAtUtc: new Date().toISOString(),
});

/** Only UUID-backed catalog/artifact identities may be sent to the BFF. */
export const metricUuid = (value: string | undefined | null) => {
    if (!value) return undefined;
    // System.Text.Json's Guid converter accepts the hyphenated wire format.
    // Backend artifacts use compact IDs, so normalize before posting to the BFF.
    if (/^[0-9a-f]{32}$/i.test(value)) {
        return [value.slice(0, 8), value.slice(8, 12), value.slice(12, 16),
            value.slice(16, 20), value.slice(20)].join("-").toLowerCase();
    }
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value)
        ? value.toLowerCase()
        : undefined;
};
